<div
  class="med-accordion"
  [ngClass]="containerClassList"
>
  <div
    class="med-accordion__header"
    [ngClass]="headerClass"
    (click)="setActive()"
  >
    <ng-content></ng-content>

    <med-icon-chevron-down
      size="16"
      class="med-accordion__icon"
      [ngClass]="active ? 'rotate' : ''"
    ></med-icon-chevron-down>
  </div>

  <div
    *ngIf="active"
    class="med-accordion__content"
    [ngClass]="contentClass"
  >
    <ng-content select="[content]"></ng-content>
  </div>
</div>
